module.exports = {
  computed: {
    indexPath() {
      var path = [this.index];
      var parent = this.$parent;
      while (parent.$options.componentName !== 'ZkMenu') {
        if (parent.index) {
          path.unshift(parent.index);
        }
        parent = parent.$parent;
      }
      return path;
    },
    rootMenu() {
      var parent = this.$parent;
      while (parent.$options.componentName !== 'ZkMenu') {
        parent = parent.$parent;
      }
      return parent;
    }
  }
};



// WEBPACK FOOTER //
// ./src/packages/menu/src/menu-mixin.js